/* eslint-disable no-duplicate-case */
import { Button, Link, TextField } from "@shopify/polaris";
import React, { useState, useEffect } from "react";
import emoji1 from "../../assets/emoji/1.png";
import emoji2 from "../../assets/emoji/2.png";
import emoji3 from "../../assets/emoji/3.png";
import emoji4 from "../../assets/emoji/4.png";
import emoji5 from "../../assets/emoji/5.png";
import gift2 from "../../assets/gift/2.png";
import callApi from "../../utils/apiCaller";
import "../../css/confetti.scss";
import Confetti from "./christmas/Confetti";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
const Feedback = (props) => {
  const [submitStatus, setsubmitStatus] = useState(false);
  const dataSettings = useSelector((state) => state.dataSettings);
  const [suggest, setsuggest] = useState("");
  const [star, setstar] = useState(0);
  const [feedback, setfeedback] = useState([]);
  const listIcon = [
    { id: 1, src: emoji1 },
    { id: 2, src: emoji2 },
    { id: 3, src: emoji3 },
    { id: 4, src: emoji4 },
    { id: 5, src: emoji5 },
  ];
  const listFeedback = [
    { id: 1, content: "Ease of use" },
    { id: 2, content: "Speed of service" },
    { id: 3, content: "Interface" },
    { id: 4, content: "Customer Support" },
    { id: 5, content: "Price" },
    { id: 6, content: "Other features" },
  ];
  const chooseFeedback = (content) => {
    let newFeedback = [...feedback];
    if (!newFeedback.includes(content)) {
      newFeedback.push(content);
    } else {
      let index = newFeedback.findIndex((x) => x === content);
      newFeedback.splice(index, 1);
    }
    setfeedback(newFeedback);
    setsubmitStatus(false);
  };
  const submitFeedback = () => {
    callApi("get", {
      action: "submitFeedback",
      type:
        props.type === "step" ? "feedback_after_ugrade" : "feedback_dashboard",
      star: star,
      feedback: JSON.stringify(feedback),
      suggest: suggest,
    }).then(async (res) => {
      if (res.data.state === 1) {
        if (props.type === "step") {
          Swal.fire({
            imageUrl: gift2,
            imageWidth: "75%",
            title: "Submit successfully",
            showConfirmButton: true,
          }).then((result) => {
            if (result.value) {
              window.location.reload();
            }
          });
        } else {
          setsubmitStatus(true);
        }
      }
    });
  };

  return (
    <div className="feedback-card">
      {props.type === "step" ? <Confetti /> : null}
      {props.type === "step" ? (
        <div>
          <h5 className="mt-2 feedback-card-title text-center">
            You got your gift! We love that you can share your feedback to us
          </h5>
          <p style={{ fontSize: "15px" }} className="mt-3 text-center">
            How was your experience?
          </p>
        </div>
      ) : null}
      <div className="feedback-card-list-icon mt-4">
        {listIcon.map((icon, index) => {
          return (
            <img
              onClick={() => setstar(icon.id)}
              className={star == icon.id ? "active" : ""}
              width={70}
              key={index}
              src={icon.src}
            />
          );
        })}
      </div>
      {props.type === "step" ? (
        <p style={{ fontSize: "15px" }} className="mt-3 text-center">
          Please tell us what can be Improved?
        </p>
      ) : (
        <p className="feedback-card-title mt-4 w-100">
          Please tell us what can be Improved?
        </p>
      )}
      <div className="feedback-card-list-content mt-5">
        {listFeedback.map((item, index) => {
          return (
            <span
              className={feedback.includes(item.content) ? "active" : ""}
              onClick={() => chooseFeedback(item.content)}
              key={index}
            >
              {item.content}
            </span>
          );
        })}
      </div>
      {star != 5 ? (
        <div className="mt-4">
          {props.type !== "step" ? (
            <TextField
              placeholder="Other suggestions..."
              value={suggest}
              onChange={setsuggest}
              multiline={4}
              autoComplete="off"
              maxLength={255}
              showCharacterCount
            />
          ) : null}
        </div>
      ) : (
        <div className="mt-5 text-center feedback-card-link">
          Can you help us to public your happy review on Shopify app store{" "}
          <b>
            <Link
              external
              url="https://apps.shopify.com/synctrack?modal-show=ReviewListingModal?reveal_new_review=true"
            >
              RIGHT HERE
            </Link>
          </b>
          ? <br /> That makes our day a lot!
        </div>
      )}
      {star != 5 ? (
        <div className="mt-5 text-center">
          <Button
            onClick={submitFeedback}
            disabled={star != 0 && feedback.length > 0 ? false : true}
            primary
          >
            {submitStatus ? "Submitted" : "Submit"}
          </Button>
        </div>
      ) : (
        <div className="mt-4 text-center">
          <Button onClick={submitFeedback} primary>
            {submitStatus ? "Submitted" : "Submit"}
          </Button>
        </div>
      )}
      {submitStatus ? (
        <p className="mt-4 text-center">
          <b>
            Your feedback really means to us. Thank you so much for your
            feedback!
          </b>
        </p>
      ) : null}
    </div>
  );
};

export default Feedback;
